import { createContext, useContext, useState, ReactNode } from "react";
import { Dialog } from "ui/components/Dialog";
import { DialogOptions } from "./types";
import { useTranslate } from "helpers";


type DialogContextState = {
  createDialog: (options: DialogOptions) => void;
};

const DialogContext = createContext<DialogContextState>({
  createDialog: () => {}
});

export const useDialog = () => useContext(DialogContext);

export const DialogProvider = ({ children }: { children: ReactNode }) => {
  const { t } = useTranslate();
  const [isOpen, setIsOpen] = useState(false);
  const [options, setOptions] = useState<DialogOptions>({});

  const createDialog = (newOptions: DialogOptions) => {
    setOptions(newOptions);
    setIsOpen(true);
  };

  const handleConfirm = () => {
    options.onConfirm?.();
    setIsOpen(false);
  };

  const handleCancel = () => setIsOpen(false);

  return (
    <DialogContext.Provider value={{ createDialog }}>
      {children}

      {/* GLOBALNI DIALOG */}
      <Dialog
        open={isOpen}
        title={options.title || t("admin.modal.dialog.confirmation.title")}
        message={options.message || t("admin.modal.dialog.confirmation.message")}
        confirmText={options.confirmText || t("admin.modal.dialog.confirmation.confirmtext")}
        cancelText={options.cancelText || t("admin.modal.dialog.confirmation.canceltext")}
        onConfirm={handleConfirm}
        onCancel={handleCancel}
      />
    </DialogContext.Provider>
  );
};

export default DialogProvider;

